export default {
	"number": {
		"platformName": "跟踪平台",
		"gpsSyncQuery": "GPS同步查询",
		"dataAbnormal": "数据异常",
		"vehicleLocation": "车辆定位",
		"basicInformation": "基本信息",
		"businessPartner": "业务伙伴",
		"platformAccount": "账号",
		"organizationNumber": "组织号",
		"platformKey": "密钥",
		"sourceType": "来源类型",
		"testTips": "测试一下此配置是否正确",
		"test": "测试",
		"plateNumber": "车牌",
		"deviceNumber": "设备号",
		"temperature": "温度",
		"locationTime": "定位时间",
		"location": "定位",
		"addTrackingAccount": "添加跟踪账号",
		"self": "自己",
		"ownVehicle": "自有车辆",
		"internalSharingVehicle": "内部共享车辆",
		"externalSharingVehicle": "外部共享车辆",
		"accountOrKeyError": "账号或秘钥错误",
		"checkTips": "请先测试通过此账号配置",
		"g7OrganizationNumber": "G7平台请输入机构号",
		"selectBusinessPartner": "请选择业务伙伴"
	},
	"synchronousQuery": {
		"asyncTime": "同步时间",
		"requestData": "访问数据",
		"resultData": "返回数据",
		"asyncInfo": "同步信息"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/number/number.js